import { Component, computed, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import { TENANT_ID } from 'src/app/authorization/authorization-factories';
import { Login, Logout } from '../../state/application.actions';
import { ApplicationState } from '../../state/application.state';
import { ComponentBaseDirective } from '../component.base';

@Component({
    selector: 'app-portal-header',
    templateUrl: './portal-header.component.html',
    styleUrls: ['./portal-header.component.scss'],
    standalone: false,
})
export class PortalHeaderComponent extends ComponentBaseDirective {
    public override readonly store = inject(Store);
    public tenantId = inject(TENANT_ID);

    public language$ = this.translationService.languageChanges$;

    public isNotificationsShown = false;
    public imageWasLoaded = false;

    @Input() public displaySettings = true;

    @ViewChild('notificationArea') public notificationArea: ElementRef;

    public isUserLoggedIn = this.store.selectSignal(ApplicationState.isUserLoggedIn);
    public username = this.store.selectSignal(ApplicationState.currentUserName);
    public selectedLanguage = toSignal(this.language$);
    public flagBackgroundImage = computed(() => {
        const language = this.selectedLanguage();
        return `url(assets/flags/${language}.svg)`;
    });

    constructor() {
        super();
    }

    public login() {
        this.store.dispatch(new Login());
    }

    public logout() {
        this.store.dispatch(new Logout());
    }

    public imageLoaded() {
        this.imageWasLoaded = true;
    }

    public changeLanguage() {
        const languages = this.translationService.getAvailableLanguages();
        const index = languages.findIndex((language) => language === this.translationService.getActiveLanguage());
        const nextLanguage = languages[index + 1] ?? languages[0];
        this.translationService.setActiveLanguage(nextLanguage as string);
    }
}
